import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  DocumentPendingToPackAction,
  ChangeStatusToPackAction,
  ChangeStatusToDeliveryAction,
  DocumentsPendingToLabelAction,
  DocumentsPendingToDeliveryAction,
  DocumentSearchAction,
} from "../../redux/actions/documentPacking.actions";
import { Container, Row, Col } from "react-grid-system";
import { useHistory } from "react-router-dom";
import logo from "../../img/logo.png";
import magnifyingGlass from "../../img/search.svg";
import { getName, close, authenticateUser, validateToken } from "../../utils/Commons.js"
import Pagination from "@material-ui/lab/Pagination";
import Navbar from "../../components/navbar"

/*Component o Page*/
function DocumentPendingToPack({
  DocumentPendingToPackAction,
  response,
  loadingScreen,
  ChangeStatusToPackAction,
  ChangeStatusToDeliveryAction,
  DocumentSearchAction,
  DocumentsPendingToLabelAction,
  DocumentsPendingToDeliveryAction,
}) {
  const [documentId, setDocumentId] = useState("");
  const [selectedRow, setSelectedRow] = useState(-1);
  const [detailDocument, setDetailDocument] = useState([]);
  const [currentWarehouse, setCurrentWarehouse] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);
  const [searcher, setSearcher] = useState("");
  let history = useHistory();
  const availableWarehouses = ['SIN FILTRO','CARRASCAL','MERMAS','EXHIBICION','HUALTATAS','COMODATO','RESERVA','SUC CARRASCAL',
                               'TEMUCO','PANELES','PROCESO','PUERTO MONTT','MERMA_INCOMPLETOS']

  useEffect(() => {
    DocumentPendingToPackAction();
  }, []);

  // If user is already login in, verify if the user has permission in the Packing module.
  // If user is not loged in, validates its token and if user has permission in the Packing module.
  useEffect(() => {
    if(!localStorage.getItem("token")){
      authenticateUser('Packing')
    }else{
      validateToken(localStorage.getItem("token"),'Packing')
    }
  })

  useEffect(() => {
    if (!response) return;
    setDetailDocument(response.data);
    if (!response.meta) return;
    setMaxPages(+response.meta.max_pages)
  }, [response]);

  function handleClick(id, index) {
    setDocumentId(id);
    setSelectedRow(index);
  }

  const toPack = (documentId) => {
    ChangeStatusToPackAction(documentId);
    window.location.href = `/documentPacking/${documentId}`
  };

  const toCompleted = () => {
    history.push(`/completedPackingList`);
  }

  const toDelivery = (documentId) => {
    ChangeStatusToDeliveryAction(documentId);
    if (!detailDocument) return;
    setDetailDocument(
      detailDocument.filter((item) => item.attributes.id !== documentId)
    );
    setSelectedRow(-1);
  };

  const filterByWarehouse = (warehouse) => {
    const data = {
      current_page: currentPage,
      warehouse: warehouse,
    };
    setCurrentWarehouse(warehouse)
    DocumentPendingToPackAction(data)
  }

  const handleSearch = () => {
    const data = {
      search: searcher,
      warehouse: currentWarehouse
    };
    DocumentSearchAction(data);
  };

  const handleChange = (event, value) => {
    const data = {
      current_page: value,
      warehouse: currentWarehouse
    };
    setCurrentPage(value)
    DocumentPendingToPackAction(data)
  }

  const toLogin = () => {
    localStorage.setItem("module", "Packing");
    history.push("/login");
  };


  return (
    <div>
      {loadingScreen ?
        <div className='loading-modal'>
          <div className='loading-modal-logo'>
            <figure>
              <img className='rotation-zoom' src={logo} alt="hbt logo" />
				    </figure>
          </div>
        </div>
        :
        null
      }
      <Navbar module="Packing" title="Packing" navBarName= 'Preparaciones pendientes'/>
      <Container className="body-height">
        <div className='row'>
          <div className='col-12'>
            <div className="headData">
              <label className="title">Preparaciones vigentes</label>
            </div>
          </div>
        </div>
        <div className='row mb-5'>
          <div className='col-12 text-center'>
            <button className="btn btn-primary mr-4">
                Preparaciones Pendientes
              </button>

              <button
                className="btn btn-outline-primary"
                onClick={() => {
                  toCompleted();
                }}> Preparaciones Completadas </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <label className="title mr-3">Bodega:</label>
            <select className="select" name="select-document_type" id="select-document_type" 
                                       onChange={(e) => {filterByWarehouse(e.target.value);}}>
              {availableWarehouses.map((warehouse) => <option key={warehouse} value={warehouse == 'SIN FILTRO' ? '' : warehouse}>{warehouse}</option>)}
            </select>
          </div>
          <div className='col-6'>
            
           
          </div>
        </div>
         
          <Row >
            <Col sm={4}>
              <div className="inputContainerSearch">
                <input
                  className="inputSearch"
                  type="text"
                  placeholder="Buscar"
                  onKeyDown={(e) => (e.key === "Enter" ? handleSearch() : null)}
                  defaultValue={searcher}
                  onChange={(e) => {
                    setSearcher(e.target.value);
                  }}
                />
                <input
                  type="image"
                  className="inputImgSearch"
                  src={magnifyingGlass}
                  border="0"
                  alt="Search"
                  onClick={() => handleSearch()}
                />
              </div>
            </Col>
            <Col sm={4} className="my-3">
              <Pagination count={maxPages} page={currentPage} onChange={handleChange} color="primary"/>
            </Col>
            <Col sm={4}> <div className="containerButtons pt-0">
              <button
                className="btn btn-primary"
                disabled={!documentId}
                onClick={() => {
                  toPack(documentId);
                }}
              >
                Embalar
              </button>

              <button
                className="btn btn-primary"
                disabled={!documentId}
                onClick={() => {
                  toDelivery(documentId);
                }}
              >
                Entregar
              </button>
            </div></Col>
          </Row>
        <Row>
          <Col sm={12}>
            <div className="listData">
              <table className="table">
                <thead>
                  <tr>
                    <td>Nro.</td>
                    <td>Tipo Doc. Origen</td>
                    <td>Nro Doc. Origen</td>
                    <td>Cant. Líneas</td>
                    <td>Cant. Producto</td>
                    <td>Pickeador</td>
                    <td>Comuna</td>
                    <td>Tipo de Despacho</td>
                  </tr>
                </thead>
                {detailDocument
                  ? detailDocument.map((item, index) => {
                      if(item === null){return}
                      else {
                        return (
                        <tbody key={item + index}>
                          <tr
                            style={{ cursor: "pointer" }}
                            key={index}
                            onClick={() =>
                              handleClick(item.attributes.id, index)
                            }
                            className={
                              selectedRow === index ? "selectedTableRow" : ""
                            }
                          >
                            <td>{index + 1}</td>
                            <td>{item.attributes.document_type}</td>
                            <td>{item.attributes.document_number}</td>
                            <td>{item.attributes.total_lines}</td>
                            <td>{item.attributes.pending_products}</td>
                            <td>{item.attributes.picked_by}</td>
                            <td>{item.attributes.comune}</td>
                            <td>{item.attributes.delivery_type}</td>
                          </tr>
                        </tbody>
                      );}
                      
                    })
                  : null}
              </table>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className="containerButtons">
              <button
                className="btn btn-primary"
                disabled={!documentId}
                onClick={() => {
                  toPack(documentId);
                }}
              >
                Embalar
              </button>

              <button
                className="btn btn-primary"
                disabled={!documentId}
                onClick={() => {
                  toDelivery(documentId);
                }}
              >
                Entregar
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

/*Methodo*/
const mapStateToProps = (state, props) => {
  return {
    response: state.documentPackingReducers.documentPendingToPackResponse.res,
    loadingScreen: state.documentPackingReducers.loadingScreen
  };
};

/*Export*/
export default connect(mapStateToProps, {
  DocumentPendingToPackAction,
  ChangeStatusToPackAction,
  ChangeStatusToDeliveryAction,
  DocumentsPendingToLabelAction,
  DocumentsPendingToDeliveryAction,
  DocumentSearchAction,
})(DocumentPendingToPack);
